import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { InformationComponent } from '../../../../shared/modals/information/information.component';
import { PreferenceMessages } from '../../../../shared/models/component-messages/preference-messages';
import { Preference, Value } from '../../model/preference';
import { PreferencesService } from '../../services/preferences.service';
import cloneDeep from 'lodash.clonedeep';
import { PreferenceAcheteurEnum, PreferenceAcheteurPrincipal } from '../../model/preference-acheteur-principal';
import { PreferenceType } from '../../../../shared/models/enum/preferenceType';
import { AutoCompleteService } from '../../../../shared/services/auto-complete.service';
import { OtherOptionComponent } from '../../../../shared/modals/other-option/other-option.component';
import { RadioCheckBoxEnum } from '../../../../formulaires/common/radio.checkbox.enums';

@Component({
  selector: 'app-preference-acheteur-principal-detail',
  templateUrl: './preference-acheteur-principal-detail.component.html',
  styleUrls: ['./preference-acheteur-principal-detail.component.scss']
})
export class PreferenceAcheteurPrincipalDetailComponent implements OnInit, OnDestroy  {

  public preferenceMessages = new PreferenceMessages();
  private unsubscribe$ = new Subject<void>();
  public form: FormGroup;
  public radios = [];
  public optionsPays: any[] = [];
  public optionsNuts = [];
  public optionsNutsModal = [];
  
  public readonly ouiValue = RadioCheckBoxEnum.ouiValue;
  public readonly nonValue = RadioCheckBoxEnum.nonValue;

  action: string;
  id: string;

  preferenceOriginal: PreferenceAcheteurPrincipal = new PreferenceAcheteurPrincipal;
  preference: PreferenceAcheteurPrincipal = new PreferenceAcheteurPrincipal;
  buttonOtherOptionLabel = 'eform-editable.button-other-option';

  radioButtonValue;

  constructor(private modalService: NgbModal, private preferenceService: PreferencesService, private router: Router, private route: ActivatedRoute, private autoCompleteService:AutoCompleteService) { }

  ngOnInit(): void {
    this.form = new FormGroup({});
    this.radios.push({ value: true, label: 'Oui' });
    this.radios.push({ value: false, label: 'Non' });
    this.initParam();
    if (this.action === "modifier") {
      this.getPreference();  
    }

    if (this.preference.personnePhysique === true) {
        this.radioButtonValue = true;
    }
    else {
          this.radioButtonValue = false;
    }

    this.autoCompleteService.countries$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(pays => {
        this.optionsPays = pays;
      });
    this.autoCompleteService.nuts$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(nuts => {
      this.optionsNutsModal = nuts;
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  initParam(): void {
    this.action = this.route?.routeConfig?.data?.action
    if (this.action === "modifier") {
      this.id = this.route?.snapshot?.paramMap?.get('id');
    }
  }

  retour(): void {
    this.router.navigate(['/preferencesAvisPub']);
  }

  annuler(): void {
    this.preference = cloneDeep(this.preferenceOriginal);
    this.initForm();
  }

  savePref(): void {
    let prefToSave = new Preference;
    prefToSave.titre = this.form.get("preference_SepAtt_acheteur_SepAtt_intitule")?.value;
    let v1 = new Value;
    v1.code = PreferenceAcheteurEnum.PERSONNE_PHYSIQUE
    v1.value = this.form.get('preference_SepAtt_acheteur_SepAtt_personne_physique')?.value;
    prefToSave.content.values.push(v1);
    let v2 = new Value;
    v2.code = PreferenceAcheteurEnum.NOM_OFFICIEL
    v2.value = this.form.get('preference_SepAtt_acheteur_SepAtt_nom_officiel')?.value;
    prefToSave.content.values.push(v2);
    let v3 = new Value;
    v3.code = PreferenceAcheteurEnum.NUM_ENREGISTREMENT
    v3.value = this.form.get('preference_SepAtt_acheteur_SepAtt_num_enregistrement')?.value;
    prefToSave.content.values.push(v3);
    let v4 = new Value;
    v4.code = PreferenceAcheteurEnum.DEPARTEMENT
    v4.value = this.form.get('preference_SepAtt_acheteur_SepAtt_departement')?.value;
    prefToSave.content.values.push(v4);
    let v5 = new Value;
    v5.code = PreferenceAcheteurEnum.ADRESSE_INTERNET
    v5.value = this.form.get('preference_SepAtt_acheteur_SepAtt_adresse_internet')?.value;
    prefToSave.content.values.push(v5);
    let v6 = new Value;
    v6.code = PreferenceAcheteurEnum.URL_ECHANGE_INFORMATION
    v6.value = this.form.get('preference_SepAtt_acheteur_SepAtt_url_echange_information')?.value;
    prefToSave.content.values.push(v6);
    let v7 = new Value;
    v7.code = PreferenceAcheteurEnum.ADR1
    v7.value = this.form.get('preference_SepAtt_acheteur_SepAtt_Adr1')?.value;
    prefToSave.content.values.push(v7);
    let v8 = new Value;
    v8.code = PreferenceAcheteurEnum.ADR2
    v8.value = this.form.get('preference_SepAtt_acheteur_SepAtt_Adr2')?.value;
    prefToSave.content.values.push(v8);
    let v9 = new Value;
    v9.code = PreferenceAcheteurEnum.ADR3
    v9.value = this.form.get('preference_SepAtt_acheteur_SepAtt_Adr3')?.value;
    prefToSave.content.values.push(v9);
    let v10 = new Value;
    v10.code = PreferenceAcheteurEnum.VILLE
    v10.value = this.form.get('preference_SepAtt_acheteur_SepAtt_ville')?.value;
    prefToSave.content.values.push(v10);
    let v11 = new Value;
    v11.code = PreferenceAcheteurEnum.CP
    v11.value = this.form.get('preference_SepAtt_acheteur_SepAtt_cp')?.value;
    prefToSave.content.values.push(v11);
    let v12 = new Value;
    v12.code = PreferenceAcheteurEnum.ENTITE_SECONDAIRE
    v12.value = this.form.get('preference_SepAtt_acheteur_SepAtt_entite_secondaire')?.value;
    prefToSave.content.values.push(v12);
    let v13 = new Value;
    v13.code = PreferenceAcheteurEnum.PAYS
    v13.value = this.form.get('preference_SepAtt_acheteur_SepAtt_pays')?.value;
    prefToSave.content.values.push(v13);
    let v14 = new Value;
    v14.code = PreferenceAcheteurEnum.POINT_CONTACT
    v14.value = this.form.get('preference_SepAtt_acheteur_SepAtt_point_contact')?.value;
    prefToSave.content.values.push(v14);
    let v15 = new Value;
    v15.code = PreferenceAcheteurEnum.EMAIL
    v15.value = this.form.get('preference_SepAtt_acheteur_SepAtt_email')?.value;
    prefToSave.content.values.push(v15);
    let v16 = new Value;
    v16.code = PreferenceAcheteurEnum.TELEPHONE
    v16.value = this.form.get('preference_SepAtt_acheteur_SepAtt_telephone')?.value;
    prefToSave.content.values.push(v16);
    let v17 = new Value;
    v17.code = PreferenceAcheteurEnum.TELECOPIEUR
    v17.value = this.form.get('preference_SepAtt_acheteur_SepAtt_telecopieur')?.value;
    prefToSave.content.values.push(v17);

    const modalRef = this.modalService.open(InformationComponent);
    modalRef.componentInstance.title = '';
    modalRef.componentInstance.OkOuRetour = true;
    if (this.action === "ajouter") {
      modalRef.componentInstance.content = this.preferenceMessages.modal_create_text;
      modalRef.dismissed.pipe(map((reason: boolean) => {
        return reason;
      }))
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: ((reason) => {
            if (reason) {
              this.preferenceService.createAcheteur(prefToSave).pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                  next: (() => {
                    this.retour();
                  })
                })
            }
          })
        })
    }
    if (this.action === "modifier") {
      prefToSave.id = Number(this.id);
      modalRef.componentInstance.content = this.preferenceMessages.modal_update_text;
      modalRef.dismissed.pipe(map((reason: boolean) => {
        return reason;
      }))
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: ((reason) => {
            if (reason) {
              this.preferenceService.updateAcheteur(prefToSave).pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                  next: (() => {
                    this.retour();
                  })
                })
            }
          })
        })
    }
  }

  getPreference() {
    this.preferenceService.getByIdAcheteur(this.id).pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((data: Preference) => {
          this.preference.id = Number(this.id);
          this.preference.titre = data.titre;
          for (let value in data.content.values) {
            switch (data.content.values[value].code) {
              case PreferenceAcheteurEnum.PERSONNE_PHYSIQUE:
                if(data.content.values[value].value === 'true')
                this.preference.personnePhysique = true;
                else if (data.content.values[value].value === 'false')
                this.preference.personnePhysique = false;
                break;
              case PreferenceAcheteurEnum.NOM_OFFICIEL:
                this.preference.nomOfficiel = data.content.values[value].value;
                break;
              case PreferenceAcheteurEnum.NUM_ENREGISTREMENT:
                this.preference.numEnregistrement = data.content.values[value].value;
                break;
              case PreferenceAcheteurEnum.DEPARTEMENT:
                this.preference.departement = data.content.values[value].value;
                break;
              case PreferenceAcheteurEnum.ADRESSE_INTERNET:
                this.preference.adresseInternet = data.content.values[value].value;
                break;
              case PreferenceAcheteurEnum.URL_ECHANGE_INFORMATION:
                this.preference.urlEchangeInformation = data.content.values[value].value;
                break;
              case PreferenceAcheteurEnum.ADR1:
                this.preference.adr1 = data.content.values[value].value;
                break;
              case PreferenceAcheteurEnum.ADR2:
                this.preference.adr2 = data.content.values[value].value;
                break;
              case PreferenceAcheteurEnum.ADR3:
                this.preference.adr3 = data.content.values[value].value;
                break;
              case PreferenceAcheteurEnum.VILLE:
                this.preference.ville = data.content.values[value].value;
                break;
              case PreferenceAcheteurEnum.CP:
                this.preference.cp = data.content.values[value].value;
                break;
              case PreferenceAcheteurEnum.ENTITE_SECONDAIRE:
                this.preference.entiteSecondaire = data.content.values[value].value;
                const itemFound = this.optionsNutsModal?.find(item => item.code === this.preference.entiteSecondaire);
                this.optionsNuts.push(itemFound);
                break;
              case PreferenceAcheteurEnum.PAYS:
                this.preference.pays = data.content.values[value].value;
                break;
              case PreferenceAcheteurEnum.POINT_CONTACT:
                this.preference.pointContact = data.content.values[value].value;
                break;
              case PreferenceAcheteurEnum.EMAIL:
                this.preference.email = data.content.values[value].value;
                break;
              case PreferenceAcheteurEnum.TELEPHONE:
                this.preference.telephone = data.content.values[value].value;
                break;
              case PreferenceAcheteurEnum.TELECOPIEUR:
                this.preference.telecopieur = data.content.values[value].value;
                break;
              default:
                break;
            }
          }
          this.initForm();
          this.preferenceOriginal = cloneDeep(this.preference);
        })
      })
  }

  partageReturn(event) {
    if (event.type === PreferenceType.ACHETEUR) {
      this.router.navigate([location.pathname + '/' + event.id]);
    } else {
      this.router.navigate(['/preferencesAvisPub']);
    }
  }

  initForm() {
    this.form.get("preference_SepAtt_acheteur_SepAtt_intitule")?.setValue(this.preference.titre);
    this.form.get('preference_SepAtt_acheteur_SepAtt_personne_physique')?.setValue(this.preference.personnePhysique);
    this.form.get('preference_SepAtt_acheteur_SepAtt_nom_officiel')?.setValue(this.preference.nomOfficiel);
    this.form.get('preference_SepAtt_acheteur_SepAtt_num_enregistrement')?.setValue(this.preference.numEnregistrement);
    this.form.get('preference_SepAtt_acheteur_SepAtt_departement')?.setValue(this.preference.departement);
    this.form.get('preference_SepAtt_acheteur_SepAtt_adresse_internet')?.setValue(this.preference.adresseInternet);
    this.form.get('preference_SepAtt_acheteur_SepAtt_url_echange_information')?.setValue(this.preference.urlEchangeInformation);
    this.form.get('preference_SepAtt_acheteur_SepAtt_Adr1')?.setValue(this.preference.adr1);
    this.form.get('preference_SepAtt_acheteur_SepAtt_Adr2')?.setValue(this.preference.adr2);
    this.form.get('preference_SepAtt_acheteur_SepAtt_Adr3')?.setValue(this.preference.adr3);
    this.form.get('preference_SepAtt_acheteur_SepAtt_ville')?.setValue(this.preference.ville);
    this.form.get('preference_SepAtt_acheteur_SepAtt_cp')?.setValue(this.preference.cp);
    this.form.get('preference_SepAtt_acheteur_SepAtt_entite_secondaire')?.setValue(this.preference.entiteSecondaire);
    this.form.get('preference_SepAtt_acheteur_SepAtt_pays')?.setValue(this.preference.pays);
    this.form.get('preference_SepAtt_acheteur_SepAtt_point_contact')?.setValue(this.preference.pointContact);
    this.form.get('preference_SepAtt_acheteur_SepAtt_email')?.setValue(this.preference.email);
    this.form.get('preference_SepAtt_acheteur_SepAtt_telephone')?.setValue(this.preference.telephone);
    this.form.get('preference_SepAtt_acheteur_SepAtt_telecopieur')?.setValue(this.preference.telecopieur);
  }

  openModalOtherOption() {
    const modalRef = this.modalService.open(OtherOptionComponent);
    modalRef.componentInstance.optionsWithCode = this.optionsNutsModal;
    modalRef.componentInstance.valueSelectedOutput
      .subscribe({
        next: (data: any) => {
          switch (data) {
            case "EMPTY":
              this.form.patchValue({preference_SepAtt_acheteur_SepAtt_entite_secondaire: null})
              break;
  
            case null:
              break;
  
            default:
              this.optionsNuts = [];
              this.optionsNuts.push(data)
              this.form.patchValue({preference_SepAtt_acheteur_SepAtt_entite_secondaire: data.code})
              break;
          }
        }
      });
  }
}

